import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { Services } from "@/components/site/Services";
import { BrandShowcase } from "@/components/site/BrandShowcase";
import { Projects } from "@/components/site/Projects";
import { VideoShowcase } from "@/components/site/VideoShowcase";
import { TrustBadges } from "@/components/site/TrustBadges";
import { Financing } from "@/components/site/Financing";
import { GoogleReviews } from "@/components/site/GoogleReviews";
import { OwnerTrust } from "@/components/site/OwnerTrust";
import { Warranties } from "@/components/site/Warranties";
import { Process } from "@/components/site/Process";
import { ServiceAreas } from "@/components/site/ServiceAreas";
import { FAQ } from "@/components/site/FAQ";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";
import { StickyCTA } from "@/components/site/StickyCTA";
import { QuoteModal } from "@/components/site/QuoteModal";

export default function Home() {
  return (
    <div className="App bg-background">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <TrustBadges />
        <Services />
        <BrandShowcase />
        <Projects />
        <VideoShowcase />
        <OwnerTrust />
        <Financing />
        <Warranties />
        <Process />
        <ServiceAreas />
        <GoogleReviews />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
      <QuoteModal />
    </div>
  );
}
